import type { FaireProductEntity } from "../../entity_types/product";

export const p_mc6ysyjy8c: FaireProductEntity = {
  token: "p_mc6ysyjy8c",
  type: "product",
  name: "Sodalite DT - 5 pcs & Velvet Bag",
  brandToken: "b_ciwhgi8nfq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b3fd4b9a6e2b858f6abd10e1087478c87228ab53714d34bee6b34bafbaaef88d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e322a8f14f73cc81547d594f58b6de7786f42ce30000ac85db899af25db2fc1.jpeg",
    "https://cdn.faire.com/fastly/cea8463925d503cac44c67a1013a09f124b3f8fed124522f5a52738bc2a4ae09.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "This listing is for five 2 inch DT (double terminated) Sodalite. Each set comes with a black velvet bag. \n\nYou will get 1 set of 5 DTs. Pieces will vary from photo. \n\nMaterial is from Brazil, sold in the US. ",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:03.410Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
